import { motion } from "framer-motion";
import backgroundSection from "../../assets/backgroundSection.webp";

export default function Banner() {
	return (
		<section className="relative w-full h-[500px] overflow-hidden">
			<img
				src={backgroundSection}
				alt="Sección"
				className="w-full h-full object-cover"
			/>

			<motion.div
				initial={{ opacity: 0, y: 40 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, ease: "easeOut" }}
				viewport={{ once: true }}
				className="absolute bottom-0 w-full bg-gradient-to-t from-black/70 to-transparent py-10"
			>
				<div className="max-w-4xl mx-auto px-6 text-center">
					<p className="text-white text-xl md:text-3xl font-bold">
						Su automóvil fantástico está más cerca de lo que usted piensa
					</p>
					<p className="text-white text-lg md:text-3xl font-medium mt-2">
						Rente el vehículo de lujo de sus sueños.
					</p>
				</div>
			</motion.div>
		</section>
	);
}
